const initJsonToggle = (root = document) => {
  root.querySelectorAll(".toggle-json").forEach((btn) => {
    btn.addEventListener("click", () => {
      const pre = btn.closest(".col-sm-6").querySelector("pre.json-block");
      if (!pre) return;

      const raw = pre.dataset.raw;
      const isPretty = pre.dataset.pretty === "true";

      if (isPretty) {
        pre.textContent = raw;
        pre.dataset.pretty = "false";
      } else {
        try {
          const pretty = JSON.stringify(JSON.parse(raw), null, 2);
          pre.textContent = pretty;
          pre.dataset.pretty = "true";
        } catch (err) {
          console.warn("Invalid JSON:", err);
          pre.textContent = raw;
          pre.dataset.pretty = "false";
        }
      }
    });
  });
};


document.addEventListener("turbo:load", () => initJsonToggle());